<template>
  <nav>
    <v-navigation-drawer
      v-if="hasDrawer"
      v-model="drawer"
      app
      temporary
      :width="computedWidth"
    >
      <ModalLicencaSelect
        :modal="modalLicenca"
        @close="modalLicenca = false"
      />
      <v-list v-if="usuario">
        <v-list-item>
          <v-list-item-avatar class="cursor-pointer" color="primary mr-0" @click="openSelectLicenca">
            <span class="white--text headline">{{ usuario.nome[0] }}</span>
          </v-list-item-avatar>

          <v-list-item link>
            <v-list-item-content>
              <v-list-item-title class="title">{{ usuario.nome }}</v-list-item-title>
              <v-list-item-subtitle>{{ usuario.email }}</v-list-item-subtitle>
              <v-list-item-subtitle class="caption font-italic">{{ usuario_licenca.titulo }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list nav dense>
        <v-list-item
          v-for="(route, i) of routes"
          :key="i"
          :to="route.path">
          <v-list-item-icon>
            <v-icon>{{ route.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ route.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn block color="error" @click="logout">
            Sair
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="primary"
      dark
      extension-height="36"
    >
      <v-icon v-if="hasBackButton" left @click="$emit('backButtonClicked')">mdi-arrow-left</v-icon>
      <v-app-bar-nav-icon v-if="hasDrawer" @click.stop="drawer = !drawer" />
      <v-toolbar-title class="body-1 pl-0">
        <slot name="title">{{ title }}</slot>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <slot name="actions"></slot>
      <template v-if="hasTabs" v-slot:extension>
        <v-tabs
          v-model="tab"
          grow
          show-arrows
          height="36"
        >
          <v-tab
            v-for="i in tabsHeader"
            :key="i"
            :href="`#tab-${i}`"
          >
            {{ i }}
          </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>

    <v-tabs-items v-if="hasTabs" v-model="tab">
      <v-tab-item
        v-for="item in tabsHeader"
        :key="item"
        :value="'tab-' + item"
      >
        <slot :name="item"></slot>
      </v-tab-item>
    </v-tabs-items>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import ModalLicencaSelect from '../shared/ModalLicencaSelect';

export default {
  name: 'Navbar',
  props: {
    hasBackButton: {
      type: Boolean,
      default: false
    },
    hasDrawer: {
      type: Boolean,
      default: false
    },
    hasTabs: {
      type: Boolean,
      default: false
    },
    tabsHeader: {
      type: Array,
      default: () => ['Dados', 'Itens', 'Parcelas']
    },
    paddingTabs: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: 'Navbar Title'
    }
  },
  components: {
    ModalLicencaSelect
  },
  data: () => ({
    drawer: false,
    tab: 'tab-1',
    modalLicenca: false,
    routes: [
      { path: '/', title: 'Pedidos', icon: 'mdi-receipt' },
      { path: '/clientes', title: 'Clientes', icon: 'mdi-store' },
      { path: '/produtos', title: 'Produtos', icon: 'mdi-package-variant-closed' },
      { path: '/configuracoes', title: 'Configurações', icon: 'mdi-cog' },
    ]
  }),
  watch: {
    tab(value) {
      this.$emit('tabChanged', value);
    }
  },
  computed: {
    ...mapGetters(['usuario', 'usuario_licenca']),
    computedWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '90%';
        case 'sm': return '60%';
        case 'md': return '30%';
        case 'lg': return '30%';
        case 'xl': return '15%';
        default: return '30%';
      }
    }
  },
  methods: {
    openSelectLicenca() {
      this.modalLicenca = true;
    },
    logout() {
      if (confirm('Tem certeza que deseja sair do sistema?')) {
        this.$store.dispatch('logout');
      }
    }
  }
}
</script>